import axiosInstance from './axiosInstance';

// ========== AMS Audit Run Report Types ==========
// Mirrors the backend AuditRunReport (amsMobile.service.getAuditRunReport):
// everything the mobile field app recorded for an audit — run status, check-in,
// sign-offs, per-checkpoint results (signed evidence URLs) and module findings.

export interface RunReportCheckpoint {
  id: string;
  assetId: string;
  /** Equipment INSTANCE this row inspects; null for project-level checkpoints. */
  equipmentId: string | null;
  scope: 'project' | 'equipment';
  /** Equipment code shown to the auditor, e.g. "INV-1". '' for project-level. */
  equip: string;
  equipName?: string;
  type: string;
  title: string;
  ideal?: string;
  unit?: string;
  requiresPhoto: boolean;
  /** due | pass | fail | hold */
  status: string;
  reading?: string;
  severity?: string;
  impact?: string;
  observation?: string;
  action?: string;
  /** Freshly-signed evidence URLs. */
  attachments?: string[];
}

export interface RunReportFinding {
  id: string;
  equip: string;
  modules: string[];
  pass: boolean;
  severity?: string;
  impact?: string;
  observation?: string;
  action?: string;
  photos: string[];
}

export interface AuditRunReport {
  audit: {
    id: string;
    runStatus: string;
    approvalStatus: string;
    auditStartDate?: string;
    omsChecked: boolean;
    omsRep?: string;
    omsCheckinPhoto?: string;
    signedOff: string[];
    assetNos: Record<string, string>;
  };
  progress: { total: number; done: number; pass: number; fail: number; hold: number; due: number };
  checkpoints: RunReportCheckpoint[];
  findings: RunReportFinding[];
}

// ========== AMS Audit Run Report API Service ==========

export const amsAuditRunReportService = {
  getRunReport: async (auditId: string): Promise<AuditRunReport> => {
    const res = await axiosInstance.get(`/ams/ams-project-audits/${auditId}/run-report`);
    return res.data?.data as AuditRunReport;
  },
};

export default amsAuditRunReportService;
